import React from 'react';
import { Tabs } from 'antd';
import { useLocation, Outlet, useNavigate } from 'react-router-dom';

/* extracting Tab pane from Tabs */
const { TabPane } = Tabs;

/* React functional component */
const WeighBridgeTabLayout = () => {
  /* extracting navigate from useNavigate() */
  const navigate = useNavigate();
  /* useLocation destructuring */
  const location = useLocation();

  /* function to get the active tab key */
  const getActiveKey = () => {
    if (location.pathname.includes('edit')) {
      return 'secondWeight';
    }
    return 'firstWeight';
  };

  return (
    <div className="tabLayout">
      <Tabs
        defaultActiveKey="firstWeight"
        onTabClick={(key: string) => {
          if (key === 'secondWeight') {
            navigate('edit');
          } else {
            navigate('create');
          }
        }}
        activeKey={getActiveKey()}
        tabBarGutter={50}
        destroyInactiveTabPane
      >
        <TabPane tab="1st Weight" key="firstWeight">
          <Outlet />
        </TabPane>
        <TabPane tab="2nd Weight" key="secondWeight">
          <Outlet />
        </TabPane>
      </Tabs>
    </div>
  );
};

export default WeighBridgeTabLayout;
